<template>
  <el-dialog
    :visible.sync="visible"
    width="750px"
    append-to-body
    @close="handleClose"
  >
    <div slot="title"></div>
    <div v-loading="loading" class="poster-shell">
      <div class="dialog-tools">
        <div class="dialog-action" @click="downloadPoster">保存图片</div>
        <div class="dialog-close" @click="visible = false"><i class="el-icon-close"></i></div>
      </div>
      <div ref="posterRef" class="poster-box">
        <img
          class="poster-bg"
          crossorigin="anonymous"
          src="https://img.51xinlong.com/xladmin/hrmanage/image/signUpBg.png?any_string_is_ok99"
          alt="poster-bg"
        />
        <div class="poster-content">
          <div class="poster-title">
            <span>"{{ posterData.company_title }}"</span>
            <span v-if="posterData.hr_user_name" class="poster-hr">
              {{ posterData.hr_user_name }}<span>HR</span>
            </span>
            发布了新职位
          </div>
          <div class="poster-bottom">
            <div class="poster-info">
              <div class="salary">{{ posterData.range }}</div>
              <div class="job-line">
                <span class="job">{{ posterData.job }}</span>
                <span class="industry">{{ posterData.industry }}</span>
              </div>
              <div class="address-line">
                <img
                  class="map-icon"
                  crossorigin="anonymous"
                  src="https://xl-online.oss-cn-hangzhou.aliyuncs.com/xlminiapp/static/images/landmark_icon.png?any_string_is_ok2"
                  alt="map-icon"
                />
                <span>{{ posterData.address }}</span>
              </div>
            </div>
            <div class="poster-code-area">
              <img
                v-if="posterData.qrcode"
                class="qrcode-image"
                crossorigin="anonymous"
                :src="posterData.qrcode"
                alt="二维码"
              />
              <div v-else class="qrcode-placeholder">二维码生成中</div>
              <div class="poster-code-text">扫描二维码了解详情</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import html2Canvas from "html2canvas";

const getDefaultPosterData = () => ({
  qrcode: "",
  hr_user_name: "",
  industry: "",
  job: "",
  company_title: "",
  address: "",
  range: "",
});

export default {
  name: "RecruitQrcodeDialog",
  data() {
    return {
      visible: false,
      loading: false,
      currentTaskId: "",
      posterData: getDefaultPosterData(),
    };
  },
  methods: {
    async open(taskId) {
      if (!taskId) {
        return;
      }
      this.visible = true;
      this.loading = true;
      this.currentTaskId = taskId;
      this.posterData = getDefaultPosterData();
      try {
        const detail = await this.$api.recruitTaskDetail({ id: taskId });
        const qrcode = await this.generateRecruitQrcode(detail || {});
        this.posterData = this.buildPosterData(detail || {}, qrcode);
      } catch (error) {
        this.$message.error("获取二维码海报失败");
        this.visible = false;
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.loading = false;
      this.currentTaskId = "";
      this.posterData = getDefaultPosterData();
    },
    buildRecruitPath(detail) {
      const shopId = Array.isArray(detail.shop_ids) ? detail.shop_ids[0] : "";
      const query = this.mxEncodeParamsToLink({
        id: detail.id || this.currentTaskId,
        shop_id: shopId || "",
      });
      return `/pages/job/jobUse/jobDetail/index?${query}`;
    },
    async generateRecruitQrcode(detail) {
      const path = this.buildRecruitPath(detail);
      const result = await this.$api.createQrcode({
        path,
        appId: this.mxDomain.appId,
        id: detail.id || this.currentTaskId,
      });
      return result || "";
    },
    buildPosterData(detail, qrcode) {
      const industryList = Array.isArray(detail.ph_hr_recruit_industry_type)
        ? detail.ph_hr_recruit_industry_type
        : [];
      const salaryText =
        Number(detail.min_salary) === Number(detail.max_salary)
          ? `${Number(detail.min_salary || 0)}元/${detail.salary_type_text || ""}`
          : `${Number(detail.min_salary || 0)}-${Number(
              detail.max_salary || 0
            )}元/${detail.salary_type_text || ""}`;
      return {
        qrcode,
        hr_user_name: detail.hr_user_name || "",
        industry: industryList[0] ? industryList[0].industry_type : "",
        job: detail.recruit_post || "",
        company_title: detail.company_title || "",
        address: detail.address_text || "",
        range: salaryText,
      };
    },
    downloadPoster() {
      if (!this.$refs.posterRef) {
        return;
      }
      html2Canvas(this.$refs.posterRef, {
        useCORS: true,
        allowTaint: true,
        backgroundColor: null,
        scale: 2,
      })
        .then((canvas) => {
          const link = document.createElement("a");
          link.href = canvas.toDataURL("image/png");
          link.download = "招聘二维码海报";
          link.click();
        })
        .catch(() => {
          this.$message.error("下载失败");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.poster-shell {
  position: relative;
}

/deep/ .el-dialog {
  background: transparent;
  box-shadow: none;
}

/deep/ .el-dialog .el-dialog__header {
  padding: 0;
}

/deep/ .el-dialog .el-dialog__body {
  padding: 0 !important;
}

.dialog-tools {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 20;
}

.dialog-action {
  position: absolute;
  top: 0;
  right: 54px;
  width: 100px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  color: #fff;
  background: #32a2ff;
  border-radius: 0 0 8px 8px;
  cursor: pointer;
}

.dialog-close {
  position: absolute;
  top: 12px;
  right: 12px;
  color: #fff;
  cursor: pointer;
  i {
    font-size: 20px;
  }
}

.poster-box {
  position: relative;
  width: 750px;
  height: 596px;
}

.poster-bg {
  width: 100%;
  height: 100%;
  display: block;
}

.poster-content {
  position: absolute;
  inset: 0;
}

.poster-title {
  padding-top: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  font-size: 45px;
  font-weight: 600;
  line-height: 1.8;
}

.poster-title > span {
  display: block;
  font-size: 30px;
  font-weight: 600;
}

.poster-hr {
  margin-right: 10px;
  font-size: 28px !important;
}

.poster-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.poster-info {
  display: flex;
  flex-direction: column;
  color: #121212;
}

.salary {
  margin-top: 20px;
  font-size: 28px;
  color: #088cf3;
}

.job-line {
  margin-top: 20px;
  display: flex;
  align-items: baseline;
  color: #999;
}

.job {
  font-size: 28px;
  font-weight: 600;
  color: #282828;
}

.industry {
  margin-left: 10px;
  font-size: 18px;
  color: #282828;
}

.address-line {
  margin-top: 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 16px;
  color: #525252;
}

.map-icon {
  width: 12px;
  height: 16px;
  margin-right: 4px;
}

.poster-code-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-image,
.qrcode-placeholder {
  width: 122px;
  height: 122px;
  margin-bottom: 5px;
  background: #fff;
}

.qrcode-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 12px;
}

.poster-code-text {
  margin-bottom: 50px;
  font-size: 10px;
  color: #121212;
}
</style>
